<!-- left -->
<div>
  <app-media *ngIf="hasPhoto" [post]="post"></app-media>
  <img class="image" *ngIf="!hasPhoto" src="assets/images/trotteur.jpg" alt="Photo du cheval.">
</div>
<!-- right -->
<div class="main">
    <app-main-info [post]="post" [editable]="editable" (renewPost)="renewPost.emit($event)" (updatePost)="updatePost.emit($event)" (deletePost)="deletePost.emit($event)"></app-main-info>
    <app-secondary-info [post]="post"></app-secondary-info>
    <app-third-info [post]="post"></app-third-info>
</div>
